import React from "react";

import {
	Nav,
	Navbar,
	Container,
	NavbarBrand,
} from "react-bootstrap";

import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import Logo from "./assets/logo.svg";

import "./NavBar.css";

const NabBarInternal = observer(({ history }) => {

	const onRef = (path) => {
		history.push(path);
	};

	return (
		<div>
			<Navbar expand="sm" fixed="sticky">
				<Container>

					<NavbarBrand style={{ cursor: "pointer" }} onClick={() => onRef("/")}>
						<img src={Logo} height="60" width="100" alt="Solklart" />
					</NavbarBrand>

					<Nav className="mr-auto" navbar />

				</Container>
			</Navbar>
		</div>
	);
});

export const NavBar = inject(
	({ rootStore }) => ({ userStore: rootStore.userStore }),
)(withRouter(NabBarInternal));
